import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Header, Footer, P } from '../components';
import { H1 } from '../components/headings';
import '../scss/404.scss';

class PageNotFound extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <main className="data-not-avaibale App-content">
                    <div className="container">
                        <div className="center-box">
                            <H1 content={"Oops. This page has gone missing"} />
                            <P>You may have mistyped the address or the page may have moved.</P>
                            <Link className="green-bg-btn small-btn" to="/">Take Me Home</Link>
                            <div className="bg-picture img-fluid" style={{ backgroundImage: `url('${require('../assets/images/404-small.jpg')}')` }} alt="" ></div>
                        </div>
                    </div>
                </main>
                <Footer />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    };
}

const connectedPageNotFound = connect(mapStateToProps, null, null, {
    pure: false
})(PageNotFound);

export { connectedPageNotFound as PageNotFound };
